export default __webpack_public_path__ + "static/media/grounding.41759a6d.png";